/*
 * @Author: wsx
 * @Date: 2022-01-21 11:04:23
 * @LastEditTime: 2022-01-21 16:22:34
 * @LastEditors: your name
 * @Description: 视频监控
 */
import { request } from "../utils/request";
import { getTalkReqBody } from "../utils/util";
import { getCameraInfo, imgUpload } from "@/api/videoControl/videoApi";
// import { getLinkDeviceList } from "@/api/alarm/alarmLink";
// import { getVehicleVedioInfo } from "@/api/common";

const videoLayout = [];
let hideType = null; // 隐藏类型
let initVideoId = ""; // 视频控件容器的 id
const eventCache = new Set(); // tab隐藏时要缓存的事件
class Camera {
  // tab隐藏时要缓存的事件
  tabHideCache(fn, params) {
    if (!this.connected) {
      eventCache.add({
        fn: fn,
        params: params || null
      });
      return true;
    }
    return false;
  }

  // 处理缓存事件
  handleHideCacheCamera() {
    if (eventCache.size > 0) {
      eventCache.forEach(item => {
        item.fn(...item.params);
      });
      eventCache.clear();
    }
  }

  /**
   * @Description: 视频控件初始化 /重置位置
   * @param reqBody 初始化视频的请求体
   * {
   *      "layout":"",
   *      "snapFilePath":"snapPath",
   *      "recordFilePath":"recordPath",
   *      "width":0,
   *      "height":0,
   *      "offx":30,
   *      "offy":50,
   *      "mgx":200,
   *      "mgy":100
   * }'
   */
  initVideo(id, reqBody = { layout: 1 }) {
    const self = this;
    // 当 webcket 未连接时把事件缓存起来
    if (!this.connected) {
      this.eventCacheFn(this.initVideo, [id, reqBody]);
      return;
    }
    // tab隐藏时缓存事件
    if (!self.visibility) {
      this.tabHideCache(this.initVideo, [id, reqBody]);
      return;
    }
    videoLayout.length = reqBody.layout;
    this.stopPreview();
    initVideoId = id || initVideoId;
    reqBody = getTalkReqBody(initVideoId, reqBody);
    console.log("initVideo函数", "websock已经发出了初始化信息");
    return new Promise((resolve, reject) => {
      request("Init", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * 反初始化
   */
  unInit() {
    return new Promise((resolve, reject) => {
      request("UnInit", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * 设置布局
   */
  setLayout(layout = 1, id) {
    let reqBody = {};
    initVideoId = id || initVideoId;
    reqBody.layout = layout;
    reqBody = getTalkReqBody(initVideoId, reqBody);
    videoLayout.length = layout;
    return new Promise((resolve, reject) => {
      request("Init", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * 显示视频控件
   */
  show() {
    if (hideType === "visibility") {
      hideType = null;
      for (const item of videoLayout) {
        if (item) this.startPreview(item);
      }
    }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        request("Show", null, {
          resolve,
          reject
        });
      }, 100);
    });
  }

  /**
   * 隐藏视频控件
   */
  hide(type) {
    const stopType = ["visibility"];
    hideType = type;
    // if (stopType.includes(hideType)) {
    //   this.stopPreview();
    // }
    return new Promise((resolve, reject) => {
      request("Hide", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * 改变控件大小
   * @param {*} id dom节点id
   */
  resize(id) {
    initVideoId = id || initVideoId;
    const reqBody = getTalkReqBody(initVideoId);
    return new Promise((resolve, reject) => {
      request("Resize", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 视频控件最大化
   */
  maximized() {
    const self = this;
    if (!this.connected) {
      this.eventCacheFn(this.maximized, []);
      return;
    }
    return new Promise((resolve, reject) => {
      request("Maximized", null, {
        resolve: event => {
          self.isFullScreen = true;
          resolve(event);
        },
        reject
      });
    });
  }

  /**
   * @Description: 视频控件最大化恢复
   */
  maximizedRecovery() {
    const self = this;
    return new Promise((resolve, reject) => {
      request("MaximizedRecovery", null, {
        resolve: event => {
          self.isFullScreen = false;
          resolve(event);
        },
        reject
      });
    });
  }

  /**
   * @Description: 获取当前选中
   * @return {Object} 返回值
   *  {
   *      @param {string} index 窗口索引
   *      @param {string} cameraID 选中的摄像机ID
   *  }
   */
  getVideoIndex() {
    return new Promise((resolve, reject) => {
      request("GetIndex", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 获取当前布局
   * @return {Object} 返回值
   *  {
   *      @param {string} layout 布局
   *      @param {string} layoutName 布局名称
   *  }
   */
  getCurLayout() {
    return new Promise((resolve, reject) => {
      request("GetCurLayout", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 当前视频控件状态信息
   */
  videoState() {
    return new Promise((resolve, reject) => {
      request("VideoState", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * 打开实时视频
   * @param {*} reqBody 请求体
   *
   */
  startPreview(reqBody) {
    videoLayout[reqBody.index] = reqBody;
    return new Promise((resolve, reject) => {
      request("StartPreview", [reqBody], {
        resolve,
        reject
      });
    });
  }

  /**
   * 视频回放
   * @param {*} reqBody 请求体
   *
   */
  startPlayback(reqBody) {
    return new Promise((resolve, reject) => {
      request("StartPlayback", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 视频截图
   * @param {type}
   * @return {Object} 返回值
   *  {
   *      @param {string} cameraID 摄像机id
   *      @param {string} fileName 文件名称
   *      @param {string} fileBaseString base字符串
   *  }
   */
  getSnap(reqBody) {
    /* reqBody：{"index":"1","fileName":""} */
    return new Promise((resolve, reject) => {
      request("snap", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 开始录象
   * @param {type}
   */
  startRecord(reqBody) {
    /* reqBody：{"index":"1","fileName":""} */
    return new Promise((resolve, reject) => {
      request("startRecord", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 结束录象
   */
  stopRecord() {
    return new Promise((resolve, reject) => {
      request("startRecord", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 本地摄像机初始化
   */
  localCameraInit() {
    return new Promise((resolve, reject) => {
      request("LocalCameraInit", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 获取本地摄像机信息
   * @return {Object}
   *  {
   *      @param {string} CameraName 摄像头名称
   *      @param {string} CurResolving 当前分辨率
   *      @param {string} ResolvingList 拥有的分辨率 序列化后为Array
   *  }
   */
  getLocalCameraList() {
    return new Promise((resolve, reject) => {
      request("GetLocalCameraList", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 播放本地摄像机
   * {
   *  @param {String} CameraName 摄像头名称
   *  @param {String} CurResolving 播放分辨率
   * }
   */
  localCameraPlay(reqBody) {
    return new Promise((resolve, reject) => {
      request("LocalCameraPlay", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 停止播放本地摄像机
   * @return {Object}
   *  {
   *      @param {string} CameraName 摄像头名称
   *      @param {string} VideoFileName 保存的文件名称
   *  }
   */
  localCameraStop() {
    return new Promise((resolve, reject) => {
      request("LocalCameraStop", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 本地摄像机开始录像
   * {
   *  @param {String} CameraName 摄像头名称
   *  @param {String} VideoFileName 保存的文件名称
   *  @param {String} AudioName 麦克风名称
   * }
   */
  localCameraRecord(reqBody) {
    return new Promise((resolve, reject) => {
      request("LocalCameraRecord", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 本地摄像机停止录像
   */
  localCameraRecordStop() {
    return new Promise((resolve, reject) => {
      request("LocalCameraRecordStop", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 打开视频文件夹
   */
  openVideoFile() {
    return new Promise((resolve, reject) => {
      request("OpenVideoFile", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 打开图片文件夹
   */
  openPictureFile() {
    return new Promise((resolve, reject) => {
      request("OpenPictureFile", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 获取播放视频信息
   * @return {Object}
   *  {
   *      ················································
   *      @param {string} cameraID 选中的摄像机ID
   *      @param {Array} cameraList 播放的视频列表
   *  }
   */
  getCameraList() {
    return new Promise((resolve, reject) => {
      request("GetCameraList", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 获取当前播放视频的所有截图并直接上传
   *   @return {Boolean} 截图上传是否全部上传成功，有一个失败则为失败
   */
  async getSnapAllAndUpload() {
    const layoutObj = await this.getCurLayout();
    const layout = layoutObj.layout;
    const list = [];
    for (let index = 0; index < layout; index++) {
      try {
        const imageObj = await this.getSnap({ index });
        const imgObj = {
          baseStr: imageObj.returnValue.fileBaseString,
          imgName: imageObj.returnValue.fileName,
          cameraId: imageObj.returnValue.cameraId
        };
        const res = await imgUpload(imgObj);
        list.push(res.data);
      } catch (error) {
        console.log("error", error);
      }
    }
    return !list.includes(false); // 数组不包含失败则返回true
  }

  /**
   * @Description: 获取当前播放视频的所有截图
   * @return {Array}
   *  {
   *      @param {string} cameraID 摄像机id
   *      @param {string} fileName 文件名称
   *      @param {string} fileBaseString base字符串
   *  }
   */
  async getSnapAll() {
    const layoutObj = await this.getCurLayout();
    const layout = layoutObj.layout;
    const list = [];
    for (let index = 0; index < layout; index++) {
      try {
        const imageObj = await this.this.getSnap({ index });
        list.push(imageObj);
      } catch (error) {
        console.log("error", error);
      }
    }
    return list;
  }

  /**
   * @Description: 获取当前选中的截图并直接上传
   *  @return {Boolean} 截图上传是否成功
   */
  async snapSelectAndUpload() {
    const body = await this.getVideoIndex();
    const selectObj = body.returnValue;
    const index = selectObj.index;
    const imageObj = await this.getSnap({ index });

    const imgObj = {
      baseStr: imageObj.returnValue.fileBaseString,
      imgName: imageObj.returnValue.fileName,
      cameraId: imageObj.returnValue.cameraId
    };
    // const res = await imgUpload(imgObj);
    return imgObj; // res.data;
  }

  /**
   * @Description: 获取当前选中的截图
   *  @return {Object}
   *  {
   *      @param {string} cameraID 摄像机id
   *      @param {string} fileName 文件名称
   *      @param {string} fileBaseString base字符串
   *  }
   */
  async getSnapSelect() {
    const body = await this.getVideoIndex();
    const selectObj = body.returnValue;
    const index = selectObj.index;
    const imageObj = await this.getSnap({
      index
    });
    return imageObj;
  }

  /**
   * @Description: 获取摄像机信息
   * @param {type} obj 请求数据的参数
   *  {
   *      @param {string} cameraID 摄像机id
   *  }
   * @param index 下标
   */
  getCameraInfo(obj, index) {
    return getCameraInfo(obj).then(res => {
      // eslint-disable-next-line eqeqeq
      if (res.code == 200) {
        if (res.data) {
          const data = res.data;
          // addLog({ ...obj, type: '1' })
          return this.getCameraMsg(data, index);
        } else {
          this.$notify.error({
            title: "找不到摄像头",
            message: "找不到摄像头",
            position: "bottom-right"
          });
        }
      } else {
        this.$notify.error({
          title: "找不到摄像头",
          message: res.message,
          position: "bottom-right"
        });
      }
    });
  }

  /**
   * @Description: 摄像机信息转换
   * @param {object}  data 摄像机数据
   * @param {Number} index 下标
   */
  getCameraMsg(data, index) {
    const obj = data;
    const element = {};
    element.streamType = "0"; // 码流类型
    element.index = index;
    for (const key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key)) {
        element[key] = obj[key];
      }
    }
    return element;
  }

  /**
   * 播放摄像机视频
   * @param {array} playCamera 摄像机数据
   * @param {string} deviceIdField 摄像机id字段
   */
  playCamera(playCamera, deviceIdField) {
    const layout = playCamera.length > 16 ? 16 : playCamera.length;
    if (playCamera.length !== 0) {
      this.initVideo(null, {
        layout
      });
    }
    playCamera.forEach((item, index) => {
      const searchObj = {
        cameraId: item[deviceIdField]
      };
      console.log("Client -> playCamera -> searchObj", searchObj);
      this.getCameraInfo(searchObj, index).then(res => {
        console.log("Client -> playCamera -> res", res);
        // this.cameraParams = res
        this.startPreview(res);
      });
    });
  }

  /**
   * @Description: 视频回放
   * @param {array} params
   * [{
   *  @param cameraId 摄像头id
   *  @param startTime 回放开始时间
   *  @param endTime 回放结束时间
   * }]
   */
  playbackCamera(params) {
    const self = this;
    if (!params) {
      return false;
    }
    const layout = params.length > 16 ? 16 : params.length;
    if (params.length !== 0) {
      self.initVideo(null, {
        layout
      });
    }
    const body = [];
    params.forEach((item, index) => {
      const searchObj = {
        cameraId: item.cameraId
      };
      self.getCameraInfo(searchObj, index + 1).then(res => {
        const cameraParams = res;
        const data = JSON.parse(JSON.stringify(cameraParams));
        data.startTime = item.startTime;
        data.endTime = item.endTime;
        data.streamType = "0";
        data.index = index;
        body.push(data);
        if (index === params.length - 1) {
          self.startPlayback(body);
        }
      });
    });
  }

  /**
   * @Description: 本地摄像机初始化关闭视频，如果无参数则关闭所有
   * @param {Object} reqBody
   *  {
   *      @param {Array} index 窗口索引Array
   *  }
   */
  stopPreview(reqBody) {
    return new Promise((resolve, reject) => {
      request("StopPreview", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * 设备联动摄像机
   * @param {string} deviceType 设备类型
   * @param {array} data 设备数据
   * @param {string} deviceIdField 设备id字段
   * @param {number} playType 播放类型 1是播放  2是只要关联数据（默认播放）
   */
  linkageCamera(deviceType, data, deviceIdField, playType = 1) {
    // const lng = data.length;
    // let cameraData = [];
    return new Promise((resolve, reject) => {
      data.forEach((item, index) => {
        // getLinkDeviceList({
        //   deviceId: item[deviceIdField],
        //   deviceType: deviceType,
        //   linkDeviceType: 1101
        // }).then(res => {
        //   // eslint-disable-next-line eqeqeq
        //   if (res.code == 200) {
        //     cameraData = cameraData.concat(res.data);
        //     // eslint-disable-next-line eqeqeq
        //     if (lng == index + 1) {
        //       //  若 cameraData是空数组则就是没有关联的摄像机
        //       // eslint-disable-next-line eqeqeq
        //       if (playType == 1) {
        //         this.playCamera(cameraData, "link_device_id");
        //       }
        //       resolve(cameraData);
        //     }
        //   } else {
        //     reject(res);
        //   }
        // });
      });
    });
  }
}
export default Camera;